import { withInstall } from '@park-ui/utils'
import CigBreadcrumb from './src/index.vue'

export const ElCigBreadcrumb = withInstall(CigBreadcrumb)

export default ElCigBreadcrumb
